import {MAP_TYPE} from '../actions/types';

const INITIAL_STATE = {
  userPosition: null,
  showuserlocation: false,
  locationPermition: false,
  firstmap: true,
  tehran: true,
  center: null,
  shownearst: false,
  firstMapViewPort: false,
  Loading: false,
  zoomLevel: 11.4,
  lastZoom: 11.4,
  startTripSwiper: false,
  currentLocation: null,
};

const Map = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MAP_TYPE:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default Map;
